import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { UtilityProvider } from '../../providers/utility/utility';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { PatientProvider } from '../../providers/patient/patient';
import { AuthProvider } from '../../providers/auth/auth';

@Component({
  selector: 'patient-summary',
  templateUrl: 'patient-summary.html'
})
export class PatientSummaryComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  user: any;
  userid: string;
  user_fullname: string;

  displayedColumns = ['status', 'substatus','notes','enteredby', 'date'];
  dataSource: any;
  exportjson: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  constructor(
    private auth: AuthProvider,
    public utility: UtilityProvider,
    private dbPatient: PatientProvider
  ) {
    this.auth.getCurrentUser().then(user => {
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };

      this.dbPatient
      .listStatuses(this.program_id, this.patient.id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe(statuses => {
        this.exportjson = statuses;
        this.dataSource = new MatTableDataSource(statuses);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }      

  ngOnInit()  {
    this._program_id.takeUntil(this.ngUnsubscribe).subscribe(x => { this.program_id = x });
    this._program_name.takeUntil(this.ngUnsubscribe).subscribe(x => { this.program_name = x });
    this._patient.takeUntil(this.ngUnsubscribe).subscribe(x => { 
      this.patient = x
      if (this.patient.enrolment_received) {
        if (!(this.patient.enrolment_received instanceof Date)) {
          this.patient.enrolment_received = this.patient.enrolment_received.toDate();
        }
      }
      if (this.patient.enrolment_complete) {
        if (!(this.patient.enrolment_complete instanceof Date)) {
          this.patient.enrolment_complete = this.patient.enrolment_complete.toDate();
        }
      }
      if (this.patient.consent_verbal) {
        if (!(this.patient.consent_verbal instanceof Date)) {
          this.patient.consent_verbal = this.patient.consent_verbal.toDate();
        }
      }
      if (this.patient.consent_written) {
        if (!(this.patient.consent_written instanceof Date)) {
          this.patient.consent_written = this.patient.consent_written.toDate();
        }
      }
      if (this.patient.Enrolment_Call_1) {
        if (!(this.patient.Enrolment_Call_1 instanceof Date)) {
          this.patient.Enrolment_Call_1 = this.patient.Enrolment_Call_1.toDate();
        }
      }
      if (this.patient.Enrolment_Call_2) {
        if (!(this.patient.Enrolment_Call_2 instanceof Date)) {
          this.patient.Enrolment_Call_2 = this.patient.Enrolment_Call_2.toDate();
        }
      }
      if (this.patient.Enrolment_Call_3) {
        if (!(this.patient.Enrolment_Call_3 instanceof Date)) {
          this.patient.Enrolment_Call_3 = this.patient.Enrolment_Call_3.toDate();
        }
      }
      if (this.patient.Enrolment_Call_4) {
        if (!(this.patient.Enrolment_Call_4 instanceof Date)) {
          this.patient.Enrolment_Call_4 = this.patient.Enrolment_Call_4.toDate();
        }
      }
      if (this.patient.Enrolment_Call_5) {
        if (!(this.patient.Enrolment_Call_5 instanceof Date)) {
          this.patient.Enrolment_Call_5 = this.patient.Enrolment_Call_5.toDate();
        }
      }
      if (this.patient.Pending_Reimbursement) {
        if (!(this.patient.Pending_Reimbursement instanceof Date)) {
          this.patient.Pending_Reimbursement = this.patient.Pending_Reimbursement.toDate();
        }
      }
      if (this.patient.On_Drug) {
        if (!(this.patient.On_Drug instanceof Date)) {
          this.patient.On_Drug = this.patient.On_Drug.toDate();
        }
      }
      if (this.patient.welcome_package_ordered) {
        if (!(this.patient.welcome_package_ordered instanceof Date)) {
          this.patient.welcome_package_ordered = this.patient.welcome_package_ordered.toDate();
        }
      }
      if (this.patient.welcome_package_sent) {
        if (!(this.patient.welcome_package_sent instanceof Date)) {
          this.patient.welcome_package_sent = this.patient.welcome_package_sent.toDate();
        }
      }
      if (this.patient.welcome_letter_sent) {
        if (!(this.patient.welcome_letter_sent instanceof Date)) {
          this.patient.welcome_letter_sent = this.patient.welcome_letter_sent.toDate();
        }
      }
    });
  }

  ngOnDestroy() {
    console.log('Leave patient summary and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Status History'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'statushistory.xlsx'); // initiate a file download in browser
  }

  updateWelcomePackageOrdered() {
    if(this.patient.welcome_package_ordered) {
      const patientupdate = {
        welcome_package_ordered: this.patient.welcome_package_ordered,
        welcome_package_ordered_createdBy: this.user.name,
        welcome_package_ordered_createdById: this.user.id,
        welcome_package_ordered_createdAt: new Date()
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated the welcome package info');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the welcome package info');
      });
    }
  }

  updateWelcomePackageSent() {
    if(this.patient.welcome_package_sent) {
      const patientupdate = {
        welcome_package_sent: this.patient.welcome_package_sent,
        welcome_package_sent_createdBy: this.user.name,
        welcome_package_sent_createdById: this.user.id,
        welcome_package_sent_createdAt: new Date()
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated the welcome package info');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the welcome package info');
      });
    }
  }

  updateWrittenConsent() {
    if(this.patient.consent_written) {
      const patientupdate = {
        consent_written: this.patient.consent_written,
        consent_written_createdBy: this.user.name,
        consent_written_createdById: this.user.id,
        consent_written_createdAt: new Date()
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated the written consent info');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the written consent info');
      });
    }
  }

  updateVerbalConsent() {
    if(this.patient.consent_verbal) {
      const patientupdate = {
        consent_verbal: this.patient.consent_verbal,
        consent_verbal_createdBy: this.user.name,
        consent_verbal_createdById: this.user.id,
        consent_verbal_createdAt: new Date()
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated the verbal consent info');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the verbal consent info');
      });
    }
  }

  clearWelcomePackageOrdered()  {
    if(this.patient.welcome_package_ordered) {
      const patientupdate = {
        welcome_package_ordered: null,
        welcome_package_ordered_createdBy: null,
        welcome_package_ordered_createdById: null,
        welcome_package_ordered_createdAt: null
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Cleared the welcome package info');
      })
      .catch(err => {
        this.utility.presentToast('Error clearing the welcome package info');
      });
    }
  }

  clearWelcomePackageSent()  {
    if(this.patient.welcome_package_sent) {
      const patientupdate = {
        welcome_package_sent: null,
        welcome_package_sent_createdBy: null,
        welcome_package_sent_createdById: null,
        welcome_package_sent_createdAt: null
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Cleared the welcome package info');
      })
      .catch(err => {
        this.utility.presentToast('Error clearing the welcome package info');
      });
    }
  }

  clearWrittenConsent()  {
    if(this.patient.consent_written) {
      const patientupdate = {
        consent_written: null,
        consent_written_createdBy: null,
        consent_written_createdById: null,
        consent_written_createdAt: null
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Cleared the written consent info');
      })
      .catch(err => {
        this.utility.presentToast('Error clearing the written consent info');
      });
    }
  }

  updateNote()  {
    if(this.patient.notes) {
      const patientupdate = {
        notes: this.patient.notes
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated patient notes');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the patient notes');
      });
    }
  }

  clearVerbalConsent()  {
    if(this.patient.consent_verbal) {
      const patientupdate = {
        consent_verbal: null,
        consent_verbal_createdBy: null,
        consent_verbal_createdById: null,
        consent_verbal_createdAt: null
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Cleared the verbal consent info');
      })
      .catch(err => {
        this.utility.presentToast('Error clearing the verbal consent info');
      });
    }
  }

  checkDate(value)  {
    if(value) {
      if (typeof value === 'object')  {
        return value;
      } else {
        return  null;
      }
    } else {
      return null;
    }
  }

  updateConsent() {
    if(this.patient.consent) {
      const patientupdate = {
        consent: this.patient.consent,
        consent_createdBy: this.user.name,
        consent_createdById: this.user.id,
        consent_createdAt: new Date()
      }
      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast('Updated the consent');
      })
      .catch(err => {
        this.utility.presentToast('Error updating the consent info');
      });
    }
  }

  saveDate(form_field: string) {
    if(this.patient[form_field]) {
      const patientupdate = {};
      patientupdate[form_field] = this.patient[form_field];
      patientupdate[form_field + '_createdBy'] = this.user.name;
      patientupdate[form_field + '_createdById'] = this.user.id;
      patientupdate[form_field + '_createdAt'] = new Date();

      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast(`Updated the ${form_field} info`);
      })
      .catch(err => {
        this.utility.presentToast(`Error updating the ${form_field} info`);
      });
    }
  }

  clearDate(form_field: string) {
    if(this.patient[form_field]) {
      const patientupdate = {};
      patientupdate[form_field] = null;
      patientupdate[form_field + '_createdBy'] = null;
      patientupdate[form_field + '_createdById'] = null;
      patientupdate[form_field + '_createdAt'] = null;

      this.dbPatient
      .updatePatient(this.program_id, this.patient.id, patientupdate, this.user)
      .then(() => {
        this.utility.presentToast(`Cleared the ${form_field} info`);
      })
      .catch(err => {
        this.utility.presentToast(`Error clearing the ${form_field} info`);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/patient-summary/patient-summary.ts